import { CarouselImage } from '@lib/types';
import Image from 'next/image';
import emblaStyles from './embla.module.scss';

/**
 * Carousel single image component for use when a carousel only has 1 image.
 *
 * @param props - The component props object
 * @param props.image The image object to display
 * @param props.className Optional - The class name to apply to the image. Default is embla__slide__img
 * @returns Single image carousel component
 */
const _SingleImageCarousel = ({
    image,
    className = undefined,
}: {
    image: CarouselImage;
    className?: string | undefined;
}) => {
    return (
        <Image
            loading="lazy"
            src={image.path}
            alt={image.alt}
            width={image.width}
            height={image.height}
            placeholder="blur"
            blurDataURL={image.blurDataURL}
            sizes={image.sizes}
            className={className ? className : emblaStyles.embla__slide__img}
            quality={75}
            draggable="false"
        />
    );
};

export default _SingleImageCarousel;
